import ExpensesTable from "components/pageSection/Expenses/ExpensesTable";
import React, { useEffect, useState } from "react";
import { Wrapper } from "./Expenses.styled";
import {
  callGetApiWithAuth,
  callPostApiWithAuth,
  callDeleteApiWithAuth,
} from "utils/api";
import { SuccessNotification } from "components/common";

const Expenses = () => {
  const initialValue = {
    payDate: "",
    type: "",
    user: "",
    description: "",
    amount: "",
    paidOut: "",
    projectId: "",
    method: "",
  };
  const [expensesData, setExpensesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialValue);

  const successDeleteExpenses = (data) => {
    SuccessNotification("Expense Deleted");
    callGetAPi();
  };
  const failDeleteExpenses = (err) => {
    console.log(err);
  };

  const successPostExpenses = (data) => {
    callGetAPi();
    setFormData(initialValue);
  };
  const failPostExpenses = (err) => {
    console.log(err);
  };

  const successGetExpenses = (data) => {
    setIsLoading(false);
    setExpensesData(data);
  };

  const failgetExpenses = (err) => {
    setIsLoading(false);
    console.log(err);
  };

  const callGetAPi = () => {
    callGetApiWithAuth("getAllExpenses", successGetExpenses, failgetExpenses);
  };

  const callPostApi = () => {
    callPostApiWithAuth(
      "expense",
      formData,
      successPostExpenses,
      failPostExpenses
    );
  };

  const callDeleteApi = (expenseId) => {
    const data = {
      method: "delete",
      expenseId: expenseId,
    };
    callDeleteApiWithAuth(
      "expense",
      data,
      successDeleteExpenses,
      failDeleteExpenses
    );
  };
  useEffect(() => {
    callGetAPi();
    setIsLoading(true);
  }, []);
  return (
    <Wrapper>
      <ExpensesTable
        expensesData={expensesData}
        isLoading={isLoading}
        formData={formData}
        setFormData={setFormData}
        callPostApi={callPostApi}
      />
    </Wrapper>
  );
};

export default Expenses;
